import React, { useState, useRef, useEffect } from "react";
import PopoverForm from "../../PopoverForm/PopoverForm";
import ViewSelectListagem from "./styles";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { ReactComponent as AngleDownSVG } from "../../../assets/newImages/icons/angle-down.svg";
import { Controls, Player } from "@lottiefiles/react-lottie-player";
import src from "../../../assets/jsons/Loading.json";

interface SelectListagemProps {
  options:
    | Array<{ name: string; value: any; quantidade: string | number, icon?: React.ReactNode, disabled?: boolean }>
    | any;
  value: any;
  onChange: (newValue: string, name?: string) => void;
  name?: string;
  placeholder?: string;
  label?: string;
  alignLabel?: "left" | "center" | "right";
  sizeLabel?: "small" | "medium" | "large";
  cores: Record<number, string>;
  required?: boolean;
  mostrarQuantidade?: boolean;
  color?: string;
  backgroundColor?: string;
  openUp?: boolean;
  loading?: boolean;
  disabled?: boolean;
}

export const SelectListagem: React.FC<SelectListagemProps> = ({
  options,
  value,
  placeholder,
  onChange,
  name,
  label,
  sizeLabel,
  alignLabel,
  required = false,
  cores,
  mostrarQuantidade = true,
  openUp = false,
  loading,
  disabled = false,
}) => {
  let fontLabel = sizesLabel();

  const { theme } = useTheme();

  function sizesLabel() {
    switch (sizeLabel) {
      case "small":
        return "1.5rem";
      case "medium":
        return "2.4rem";
      case "large":
        return "3rem";
      default:
        return "2.4rem";
    }
  }

  const [ativo, setAtivo] = useState(true);
  const [selecionado, setSelecionado] = useState<any>();
  const [focused, setFocused] = useState<null | number>(0);
  const [hoverEffect, setHoverEffect] = useState(false);
  const selectedOptionRef = useRef<HTMLDivElement>(null);

  const optionsHeight = options.length > 5 ? 200 : options.length * 40;

  useEffect(() => {
    if (options.length === 0) {
      return;
    }
  }, [options, value]);

  useEffect(() => {
    let option = options.find((option: any) => option.value === value);
    setSelecionado(option ? option.name : null);
  }, [options]);

  const handleSelectListagemChange = (
    event:
      | React.MouseEvent<HTMLDivElement>
      | React.KeyboardEvent<HTMLDivElement>,
    newValue: string,
    selecionado: any,
  ) => {
    // Don't do anything if the option is disabled
    if (selecionado.disabled) return;
    
    setSelecionado(selecionado);
    setAtivo(!ativo);
    name ? onChange(newValue, name) : onChange(newValue);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    setHoverEffect(false);
    if (event.key === "ArrowDown") {
      event.preventDefault();
      if (!ativo) {
        focused !== null
          ? setFocused((focused + 1) % options.length)
          : setFocused(0);
      } else {
        setAtivo(!ativo);
      }
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      if (!ativo) {
        focused !== null
          ? setFocused((focused - 1 + options.length) % options.length)
          : setFocused(options.length - 1);
      } else {
        setAtivo(!ativo);
      }
    } else if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      if (!ativo) {
        focused !== null
          ? handleSelectListagemChange(
              event,
              options[focused].value,
              options[focused].name,
            )
          : setAtivo(!ativo);
      } else {
        setAtivo(!ativo);
      }
    } else if (event.key === "Escape") {
      event.preventDefault();
      setAtivo(true);
    }
  };

  const optionsRef = useRef<HTMLDivElement>(null);
  const scrollToHighlightedOption = () => {
    if (!optionsRef.current || !focused || focused === -1) return;
    const container = optionsRef.current;
    const highlightedOption = container!.children![focused!] as HTMLElement;
    const containerTop = container.scrollTop;
    const containerBottom = containerTop + container.offsetHeight;
    const optionTop = highlightedOption.offsetTop;
    const optionBottom = optionTop + highlightedOption.offsetHeight;
    if (optionTop < containerTop) {
      container.scrollTop = optionTop;
    } else if (optionBottom > containerBottom) {
      container.scrollTop = optionBottom - container.offsetHeight;
    }
  };

  const handleCloseDropdown = (e) => {
    if (
      selectedOptionRef.current &&
      !selectedOptionRef.current.contains(e.target)
    ) {
      setAtivo(true);
      document.removeEventListener("click", handleCloseDropdown);
    }
  };

  useEffect(() => {
    scrollToHighlightedOption();
  }, [focused]);

  useEffect(() => {
    if (ativo) {
      document.removeEventListener("click", handleCloseDropdown);
    } else {
      document.addEventListener("click", handleCloseDropdown);
    }
    return () => {
      document.removeEventListener("click", handleCloseDropdown);
    };
  }, [ativo]);

  useEffect(() => {
    let option = options.find((option: any) => option.value === value);
    setSelecionado(option ? option.name : null);
  }, [options]);

  return (
    <>
      <ViewSelectListagem
        onKeyDown={handleKeyDown}
        onMouseEnter={(event) => {
          setFocused(null);
          setHoverEffect(true);
        }}
        onMouseMove={(event) => {
          setFocused(null);
          setHoverEffect(true);
        }}
        theme={theme}
      >
        <PopoverForm mensagem={"Selecione um item da lista"} />
        <select
          required={required}
          className="fonteTexto selectAuxiliar"
          tabIndex={-1}
          disabled={disabled}
          value={value}
          onChange={(event) => {
            name
              ? onChange(event.target.value, name)
              : onChange(event.target.value);
            onChange(event.target.value);
          }}
        >
          <option value="" disabled hidden>
            {placeholder}
          </option>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.name}
              
            </option>
          ))}
        </select>
        {label && (
          <div
            className={`fonteTexto label ${alignLabel && alignLabel}`}
            style={{ fontSize: fontLabel }}
          >
            {label}
          </div>
        )}
        <div
          tabIndex={0}
          className={`fonteTexto ${ativo ? "select" : "select ativo"}`}
          onClick={(e) => {
            if (disabled) return;
            setAtivo(!ativo);
            e.stopPropagation();
            if (ativo) {
              document.addEventListener("click", (e) => {
                setAtivo(true);
              });
            }
          }}
        >
          <div className={`fonteTexto ${value ? "value" : "placeholder"}`}>
            {options.find((option: any) => option.value === value)?.name ||
              placeholder}
            {mostrarQuantidade && (
              <div className="quantidade fonteRotulos">
                {options.find((option: any) => option.value === value)
                  ?.quantidade || ""}
              </div>
            )}
          </div>
          <div className="icon">
            {loading ? (
              <Player
                autoplay
                loop
                src={src}
                style={{ height: "3rem", width: "3rem" }}
              >
                <Controls
                  visible={false}
                  buttons={["play", "repeat", "frame", "debug"]}
                />
              </Player>
            ) : (
              <AngleDownSVG className="arrow" />
            )}
          </div>
        </div>
        <div
          ref={optionsRef}
          className={`fonteTexto
            ${openUp && "openUpwards"}
            ${ativo ? "options" : "option ativo scrollBonito"} 
            ${hoverEffect && "hoverEffect"} 
          `}
          style={{ maxHeight: `${optionsHeight}px` }}
        >
          {options
            .filter((option) => option.name != "Excluído")
            .map((option, index) => {
              return (
                <div
                  key={index}
                  className={`fonteTexto optionsContainer ${
                    index === focused && "focused"
                  } ${index == options.length - 1 && "last"} ${
                    option.disabled ? "disabled-option" : ""
                  }`}
                  onClick={(e) =>
                    handleSelectListagemChange(e, option.value, option)
                  }
                >
                  <div className="option-text fonteTexto">
                    {option.name}
                    {mostrarQuantidade && (
                      <div className="quantidade fonteRotulos">{option.quantidade}</div>
                    )}
                    {option.icon && <span className="option-icon">{option.icon}</span>}
                  </div>
                </div>
              );
            })}
        </div>
      </ViewSelectListagem>
    </>
  );
};
